<template>
  <div className="animated">
    <div class="animated fadeIn">
      <b-modal ref="infoModal" centered size="xl" title="Reporte de proceso" @ok="closeModal" ok-only>
        <div class="text-center">
          <b-spinner v-if="loading" label="Spinning"></b-spinner>
        </div>
        <component :is="report" :process="process" ref="report"></component>
      </b-modal>

      <b-modal ref="infoModalRepa" centered size="xl" title="Reporte de repaletizaje" @ok="closeModal" ok-only>
        <component
          :is="componenteActual"
          :process="tableDataPalletIn"
          :tableDataMovimientos="tableDataMovimientos"
          ref="ReportRepaletizaje"
        ></component>
      </b-modal>
      <b-modal
        id="modal-lg"
        ref="infoModalWaybill"
        centered
        size="lg"
        title="Guia de despacho"
        @ok="waybill = null"
        ok-only
      >
        <div class="text-center">
          <b-spinner v-if="!waybill" label="Spinning"></b-spinner>
        </div>
        <waybill-report v-if="waybill" :waybill="waybill"></waybill-report>
      </b-modal>
      <b-row class="my-2">
        <b-col>
          <h1 class="text-uppercase font-weight-bold">{{ $route.meta.label }}</h1>
        </b-col>
        <b-col>
          <b-form>
            <b-row>
              <b-col>
                <label for="monthSelect">Seleccione mes</label>
                <b-form-select
                  id="monthSelect"
                  v-model="selected.month"
                  :plain="true"
                  :options="selectOptions.months"
                  value="Seleccione..."
                >
                </b-form-select>
              </b-col>
              <b-col>
                <label for="yearSelect">Año</label>
                <b-form-select
                  id="yearSelect"
                  v-model="selected.year"
                  :plain="true"
                  :options="selectOptions.years"
                  value="Seleccione..."
                >
                </b-form-select>
              </b-col>
            </b-row>
          </b-form>
        </b-col>
      </b-row>
      <div></div>
      <v-server-table :url="url" :columns="columns" :options="options" :theme="theme" ref="table" id="dataTable">
        <template slot="afterFilter">
          <tr class="VueTables__no-results">
            <b-button @click.prevent="resetFilters">Limpiar filtro</b-button>
            <download-excel
              class="btn"
              :fetch="fetchData"
              :fields="json_fields"
              worksheet="Procesos"
              :name="name"
              :before-generate="startDownload"
              :before-finish="finishDownload"
            >
              <b-button>Descargar</b-button>
            </download-excel>
          </tr>

          <tr v-if="loading" class="VueTables__no-results">
            <b-spinner v-if="loading" variant="primary" class="ml-2 mt-1" small label="Small Spinner"></b-spinner>
          </tr>
        </template>
        <template slot="process_status" slot-scope="props">
          <div style="text-align: center">
            <!-- Cuando no esta cerrado -->
            <b-badge v-if="props.row.process_status != 2" pill :variant="getBadge(props.row.process_status)">{{
              status(props.row.process_status)
            }}</b-badge>

            <!-- Cuando no es staff y esta cerrado -->
            <b-badge
              v-if="(props.row.process_status === 2) & !$store.state.user.STAFF"
              pill
              :variant="getBadge(props.row.process_status)"
              >{{ status(props.row.process_status) }}</b-badge
            >

            <!-- Cuando es staff y esta cerrado -->
            <a
              href="#"
              v-if="(props.row.process_status === 2) & $store.state.user.STAFF"
              @click.prevent="openProcess(props.row.id)"
            >
              <b-badge pill :variant="getBadge(props.row.process_status)">{{
                status(props.row.process_status)
              }}</b-badge>
            </a>
          </div>
        </template>
        <div slot="number" slot-scope="props">
          <div style="text-align: right">{{ props.row.number }}</div>
        </div>
        <div slot="process_date" slot-scope="props">
          <div style="text-align: right">{{ props.row.process_date }}</div>
        </div>
        <div slot="shift_workers" slot-scope="props">
          <div style="text-align: right">{{ props.row.shift_workers }}</div>
        </div>
        <div slot="source_documents" slot-scope="props">
          <template v-for="it in props.row.source_documents">
            <a href="#" @click.prevent="getCompleteWaybill(it.id)">
              {{ it.number }}
            </a>
          </template>
        </div>
        <div class="text-right" slot="actions" slot-scope="props">
          <!--  <a v-if="props.row.process_status === 2" target="_blank" href="#" @click.prevent="sendEmail(props.row.id)" class="fa fa-lg fa-send text-primary"></a>&nbsp; -->
          <a
            target="_blank"
            href="#"
            @click.prevent="showProcessModal(props.row.id, props.row.process_type.process_option)"
            class="fa fa-lg fa-search text-primary mx-1"
          ></a>
          <a
            target="_blank"
            href="#"
            @click.prevent="downloadWithAxios(props.row.id, props.row.number)"
            class="fa fa-lg mx-1 fa-file-pdf-o text-primary"
          ></a>
          <a
            v-if="props.row.process_status === 2"
            target="_blank"
            href="#"
            @click.prevent="emailModal(props.row, props.row.process_type.process_option)"
            class="fa fa-lg fa-send text-primary mx-1"
          ></a>
          <router-link
            v-if="props.row.process_status == 1"
            :to="{
              path:
                '/procesos/' +
                props.row.process_type.process_option +
                '/' +
                props.row.process_type.id +
                '/editar/' +
                props.row.id
            }"
            class="fa fa-lg fa-edit text-primary mx-1"
          >
          </router-link>
          <router-link
            :to="{ name: 'procesos-registros', params: props.row }"
            v-if="props.row.process_status == 1"
            class="fa fa-lg fa-arrow-right text-primary mx-1"
          >
          </router-link>
        </div>
      </v-server-table>
    </div>

    <email-modal
      :to="to"
      :cc="cc"
      :bcc="bcc"
      :process_id="process_id"
      :process_type_option="process_type_option"
      :type="2"
      :subject="subject"
      :msg="msg"
      ref="email"
    >
    </email-modal>
  </div>
</template>

<script>
import Vue from "vue";
import { ServerTable, Event } from "vue-tables-2";
import JsonExcel from "vue-json-excel";
import moment from "moment";
import numeral from "numeral";
import locales from "numeral/locales";
import Report from "./Report2.vue";
import WaybillReport from "../recepcion/Report.vue";
import ReportRepaletizaje from "./ImprimirRepaletizaje.vue";
import emailModal from "../reusable/emailModal";

numeral.locale("es");
window.axios = require("axios");

var d = new Date();

Vue.use(ServerTable);
Vue.component("downloadExcel", JsonExcel);

import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";
import tableTexts from "../../lang/tableTexts";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

Vue.use(VueNotifications);
Vue.use(miniToastr);

export default {
  name: "DataTable",
  components: {
    ServerTable,
    Report,
    WaybillReport,
    ReportRepaletizaje,
    emailModal
  },
  created() {
    this.getSelectionSet();
  },
  mounted() {
    Event.$on("vue-tables.loading", () => {
      this.loading = true;
    });

    Event.$on("vue-tables.loaded", () => {
      this.loading = false;
    });

    this.loadYear();
    this.process_type_option_filter = this.$attrs.process_type_option;
  },
  data() {
    return {
      process_type_option_filter: null,
      waybill: null,
      process_id: null,
      process_type_option: null,
      report: "",
      loading: true,
      process: [],
      componenteActual: "",
      tableDataPalletIn: [],
      tableDataMovimientos: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      json_fields: {
        Exportadora: "client_customer",
        Huerto: "origin_name",
        "Tipo Proceso": "process_type.name",
        Numero: "number",
        // Guias: {
        //   field: "source_documents",
        //   callback: (value) => {
        //     return Array.prototype.map.call(value, (s) => s.number).toString();
        //   }
        // },
        "Fecha Proceso": {
          field: "process_date",
          callback: (value) => {
            return moment(value).format("DD-MM-YYYY");
          }
        },
        Trabajadores: "shift_workers",
        Estatus: "process_status",
        Duración: "duration",
        "Total Volteado": {
          field: "total_net_kilograms",
          callback: (value) => {
            return numeral(value).format("0.00");
          }
        },
        KExp: {
          field: "total_exportable_kilograms",
          callback: (value) => {
            return numeral(value).format("0.00");
          }
        },
        Porcentaje: {
          field: "percentages",
          callback: (value) => {
            return numeral(value).format("0.00");
          }
        }
      },
      columns: [
        "client_customer",
        "origin_name",
        "process_type.name",
        "number",
        // "source_documents",
        "process_date",
        "shift_workers",
        "process_status",
        "duration_hours",
        "total_kilograms_per_hour",
        "total_net_kilograms",
        "total_exportable_kilograms",
        "percentages",
        "actions"
      ],
      selected: {
        client_customer: "",
        process_type: "",
        plant: "",
        month: d.getMonth() + 1,
        process_status: "",
        year: d.getFullYear()
      },
      selectOptions: {
        client_customers: [{ value: "", text: "-----------" }],
        process_types: [{ value: "", text: "-----------" }],
        plants: [{ value: "", text: "-----------" }],
        process_statuses: [
          { value: "", text: "-----------" },
          { value: "1", text: "Abierto" },
          { value: "2", text: "Cerrado" }
        ],
        months: [
          { value: 1, text: "Enero" },
          { value: 2, text: "Febrero" },
          { value: 3, text: "Marzo" },
          { value: 4, text: "Abril" },
          { value: 5, text: "Mayo" },
          { value: 6, text: "Junio" },
          { value: 7, text: "Julio" },
          { value: 8, text: "Agosto" },
          { value: 9, text: "Septiembre" },
          { value: 10, text: "Octubre" },
          { value: 11, text: "Noviembre" },
          { value: 12, text: "Diciembre" }
        ],
        years: []
      },
      data: [],
      useVuex: false,
      theme: "bootstrap4",
      template: "default",
      options: {
        // skin: "table table-sm table-hover border-0",
        responseAdapter: function (resp) {
          const results = resp.data.results;
          const items = [];
          for (let key in results) {
            const item = results[key];
            results[key].process_date = moment(results[key].process_date).format("DD-MM-YYYY");
            results[key].total_kilograms = numeral(parseFloat(results[key].total_kilograms));
            results[key].percentage_exportable = numeral(parseFloat(results[key].percentage_exportable));
            items.push(item);
          }

          return {
            data: items,
            count: resp.data.count
          };
        },
        debounce: 400,
        // skin: " table-hover table-bordered",
        texts: tableTexts,
        perPage: 25,
        perPageValues: [15, 25, 50, 100],
        // columnsDropdown: true,
        filterByColumn: true,
        columnsClasses: {
          percentages: "text-right",
          total_net_kilograms: "text-right",
          total_exportable_kilograms: "text-right",
          duration_hours: "text-right",
          total_kilograms_per_hour: "text-right"
        },
        filterable: ["number", "client_customer", "process_type.name", "origin_name", "process_status", "process_date"],
        listColumns: {
          process_status: [
            { id: 1, text: "Abierto" },
            { id: 2, text: "Cerrado" },
            { id: 3, text: "Enviado" }
          ],
          client_customer: [],
          "process_type.name": []
        },
        headings: {
          client_customer: "Exportadora",
          "process_type.name": "Tipo",
          number: "Número",
          process_date: "Fecha",
          shift_workers: "Trabajadores",
          // source_documents: "Guias",
          process_status: "Estatus",
          duration: "Duracion",
          total_net_kilograms: "Kg Volteados",
          total_exportable_kilograms: "KExp",
          origin_name: "Huerto",
          percentages: "Porcentaje",
          duration_hours: "Duración",
          total_kilograms_per_hour: "Kg/Hora",
          actions: "Acciones"
        },
        sortable: [],
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          dropdown: false,
          chunk: 10
        }
      },
      to: null,
      cc: null,
      bcc: null,
      subject: null,
      msg:
        "Estimado Productor, \n" +
        "Nos es grato informarle que hemos procesado su fruta. Por favor revise en archivo adjunto los detalles del proceso.\n" +
        "\n" +
        "Atte.,"
    };
  },
  computed: {
    name() {
      return "Procesos " + moment(Date.now()).format("YYYYMMDD h:mm") + ".xls";
    },

    url() {
      return (
        "/api/v1/process/detailed/?" +
        "month=" +
        this.selected.month +
        "&year=" +
        this.selected.year +
        "&process_option=" +
        this.process_type_option_filter
      );
    }
  },
  methods: {
    resetFilters() {
      for (var key in this.$refs["table"].query) {
        this.$refs["table"].query[key] = "";
      }
      this.$refs["table"].refresh();
    },
    forceFileDownload(response, a) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Guia de despacho #" + a + ".pdf"); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    downloadWithAxios(a, b) {
      this.$axios({
        method: "get",
        url: "/reports/process_pdf/" + a,
        responseType: "arraybuffer"
      })
        .then((response) => {
          this.forceFileDownload(response, b);
          miniToastr.success("Pdf generado con éxito.", "Mensaje:");
        })
        .catch((error) => {
          miniToastr.error("Problemas al generar pdf", "Error:");
          console.log(error);
        });
    },
    sendEmail(process) {
      this.$swal
        .fire({
          title: "Se enviará informe de proceso. ¿Está seguro?",
          text: "",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#20a8d8",
          cancelButtonColor: "#f86c6b",
          cancelButtonText: "No",
          confirmButtonText: "Sí"
        })
        .then((result) => {
          if (result.value) {
            this.loading = true;
            this.$axios
              .get("/api/v1/process/" + process + "/send_email/")
              .then((res) => {
                var msg = res.data.msg;
                this.loading = false;
                miniToastr[res.data.color](msg, "");
                this.$refs["table"].refresh();
              })
              .catch((error) => {
                miniToastr.error(error, "");
                this.loading = false;
              });
          }
        });
      // /api/v1/process/198/send_email/
    },
    getCompleteWaybill(a) {
      this.$refs.infoModalWaybill.show();
      this.$axios
        .get("/api/v1/waybill/" + a + "/waybill_complete/")
        .then((res) => {
          this.waybill = res.data;
        })
        .catch((error) => console.log(error));
    },
    async fetchData() {
      const response = await this.$axios.get(this.url);
      return response.data.results;
    },
    startDownload() {
      this.loading = true;
    },
    finishDownload() {
      this.loading = false;
    },

    showProcessModal(a, typeProcess) {
      if (typeProcess == 1) {
        //this.componenteActual='report';
        this.report = "report";
        this.loading = true;
        this.$nextTick(function () {
          this.getProcess(a);
        });

        this.$refs.infoModal.show();
      }

      if (typeProcess == 2) {
        this.componenteActual = "ReportRepaletizaje";
        this.loading = true;
        this.$nextTick(function () {
          this.getProcessRepa(a);
        });

        this.$refs.infoModalRepa.show();
      }
    },
    getProcess(process_id) {
      this.$axios
        .get("/api/v1/process/" + process_id + "/detailed_with_traceability/")
        // .then(x => new Promise(resolve => setTimeout(() => resolve(x), 2000)))
        .then((res) => {
          this.process = res.data;
          this.loading = false;
        })
        .catch((error) => console.log(error));
    },
    getProcessRepa(process_id) {
      this.tableDataPalletIn = [];
      this.tableDataMovimientos = [];

      this.$axios
        .get("/api/v1/process/" + process_id + "/process_detail_repaletizaje/")
        .then((res) => {
          this.tableDataPalletIn = res.data.movement_content;
          this.loading = false;

          const datos = res.data.movement_content;

          for (let key in datos) {
            var rowNew = {
              Pallet_entrada: datos[key].content.pallet_number,
              Pallet_salida: datos[key].content_reference.pallet_number,
              Producto: datos[key].content.product_name,
              Tipo_producto: datos[key].content.product_type_name,
              Variedad: datos[key].content.variety_name,
              origin: datos[key].content_reference.origin_name,
              kilos_brutos: datos[key].content.gross_kilograms,
              kilos_netos: datos[key].content.net_kilograms,
              Cantidad: datos[key].content.quantity,
              IDContenido: datos[key].content.id,
              container: datos[key].content_reference.container.name,
              condition: datos[key].content_reference.condition,
              variety: datos[key].content_reference.variety_name,
              creation_date: datos[key].content_reference.creation_date,
              plant: datos[key].content_reference.plant
            };

            this.tableDataMovimientos.push(rowNew);
          }
        })
        .catch((error) => console.log(error.message));
    },

    closeModal() {
      this.$refs.report.process = [];
      this.process = [];
      this.report = "";
    },
    status(process_status) {
      return process_status === 2 ? "CERRADO" : process_status === 3 ? "ENVIADO" : "ABIERTO";
    },
    getBadge(process_status) {
      return process_status === 2 ? "dark" : process_status === 3 ? "success" : "light";
    },
    getSelectionSet() {
      this.$axios
        .get("/api/v1/client/process_select_input/")
        .then((res) => {
          this.selectOptions.plants = res.data.plants;
          this.selectOptions.plants.push({ value: "", text: "-----------" });

          const client_customers = res.data.client_customers;
          for (let idx in client_customers) {
            const item = {
              id: client_customers[idx]["value"],
              text: client_customers[idx]["text"]
            };
            this.options.listColumns["client_customer"].push(item);
          }

          const process_types = res.data.process_types;
          for (let idx in process_types) {
            const item = {
              id: process_types[idx]["value"],
              text: process_types[idx]["text"]
            };
            this.options.listColumns["process_type.name"].push(item);
          }
        })
        .catch((error) => console.log(error));
    },

    deleteWaybill(a, process_type_option) {
      if (process_type_option == 1) {
        miniToastr.info("Operación no permitida", "");
      }

      if (process_type_option == 2) {
        miniToastr.info("Operación no permitida", "");
      }
    },
    loadYear() {
      for (let ano = 2019; ano <= d.getFullYear(); ano++) {
        this.selectOptions.years.push({ value: ano, text: ano });
      }
    },
    emailModal(obj, process_type) {
      if (process_type == 1) {
        this.$axios({
          method: "get",
          url: "/reports/process_emails/" + obj.id
        })
          .then((res) => {
            miniToastr[res.data.color](res.data.msg, "");
            this.to = res.data.emails.to.join();
            this.cc = res.data.emails.cc.join();
            this.bcc = res.data.emails.bcc.join();
          })
          .catch((error) => {});
        this.process_id = obj.id;
        this.process_type_option = process_type;
        this.subject = "Notificación de Proceso " + obj.number;
        this.$bvModal.show("email-modal");
      }

      if (process_type == 2) {
        miniToastr.info("Opción no disponible", "");
      }
    },
    async openProcess(id) {
      const thisV = this;
      let url = "";
      thisV.loading = true;
      url = `/api/v1/process/${id}/open_process/`;
      try {
        const response = await thisV.$axios({
          method: "PUT",
          url: url
        });
        thisV.loading = false;
        thisV.$router.push("/procesos/listado");
        thisV.$swal.fire("Proceso abierto con éxito", "", "success");
        thisV.$refs["table"].refresh();
      } catch (error) {
        thisV.$toast.error(error.response.data.detail, "");
        thisV.loading = false;
      }
    }
  }
};
</script>

<style scoped>
>>> .VueTables__filters-row.form-control {
  height: calc(0.5em + 0.75rem + 2px);
}

>>> .VuePagination {
  text-align: center;
  justify-content: center;
}

>>> .table td {
  padding: 0.15em;
}

>>> .vue-title {
  text-align: center;
  margin-bottom: 10px;
}

>>> .VueTables__search-field {
  display: flex;
}
>>> .VueTables__search-field input {
  margin-left: 0.12rem;
}

>>> .VueTables__limit-field {
  display: flex;
}

>>> .VueTables__limit-field select {
  margin-left: 0.1rem !important;
}

>>> .VueTables__table th {
  text-align: center;
  padding: 0.1rem;
}

>>> .VueTables__child-row-toggler {
  width: 16px;
  height: 16px;
  line-height: 16px;
  display: block;
  margin: auto;
  text-align: center;
}

>>> .VueTables__child-row-toggler--closed::before {
  content: "+";
}
>>> .VueTables__columns-dropdown {
  padding-right: 20px;
}
>>> .VueTables__date-filter {
  border: 1px solid #ccc;
  padding: 6px;
  border-radius: 4px;
  cursor: pointer;
}
>>> .VueTables__number-field {
  border: 4px solid #ccc;
  padding: 6px;
  border-radius: 4px;
  cursor: pointer;
}
>>> .VueTables__child-row-toggler--open::before {
  content: "-";
}
</style>
